import React from 'react';

import {
  IconButton,
  TableCell,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  DownloadIcon,
} from '@gogame/components';
import { DateValueFormatter } from '@gogame/intl-ts';

const HistoryTable = ({ data = [], onExport }) => {
  return (
    <TableContainer>
      <Table width={'600px'}>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>File Name</TableCell>
            <TableCell>Uploaded By</TableCell>
            <TableCell>Uploaded</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((upload, key) => (
            <TableRow key={key}>
              <TableCell>{upload.id}</TableCell>
              <TableCell>{upload.fileName}</TableCell>
              <TableCell>{upload.uploadedBy}</TableCell>
              <TableCell>
                <DateValueFormatter
                  value={upload.uploadedDate}
                  template={'LLL'}
                  timeZone={'local'}
                />
              </TableCell>
              <TableCell width={'73px'} padding={'none'}>
                <IconButton
                  padding={'0px 0px'}
                  tooltip={'Export'}
                  icon={<DownloadIcon />}
                  onClick={() => onExport(upload.id)}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default HistoryTable;
